<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row align-v="center" class="pb-2">
          <b-col cols="6">
            <span class="h5">{{ $t('dw.report.performance.header') }}</span>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-btn @click="exportReport" variant="success" target="_blank"><i class="fa fa-download mr-2"></i>{{$t('dw.general.export')}}</b-btn>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable keywordPlaceholder="Type to Search" searchAction="getPerformanceReport" type="dw" vuexModule="Dw" :filters="filters" :autoSearchFilters="autoSearchFilters" :columns="columns" v-model="currentFilters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITSearchableTable, FITFormCard } from '@/components'
import Vue from 'vue'
import { domain } from '@/api/api.js'
import { saveAs } from 'file-saver/FileSaver';


export default {
  name: 'reportPerformance',
  components: {
    FITSearchableTable,
    FITFormCard
  },
  methods: {
    exportReport() {
      var filters = JSON.parse(JSON.stringify(this.currentFilters));
      filters.export = 1
      var params = this.$options.filters.removeEmptyObj(filters);

      this.$store.dispatch('Dw/exportPerformanceReport', params).then((json) => {
        var fileName = json.headers['content-disposition'];
        fileName = fileName.split(' ').join('');
        fileName = fileName.split('attachment;filename=').join('');
        saveAs(new Blob([json.data]), fileName);
      })
    },
    setCurrentFilters(val) {
      Vue.set(this, 'currentFilters', val);
    },
    convertEnglishName(item) {
      var englishName = Vue.options.filters.isEmpty(item['englishFirstname']);
      if (englishName !== 'N/A') {
        englishName =   item['englishLastname']+ ' ' +englishName;
      }
      return englishName;
    },
    convertChineseName(item) {
      var chineseName = Vue.options.filters.isEmpty(item['chineseFirstname']);
      if (chineseName !== 'N/A') {
        chineseName = item['chineseLastname'] + chineseName;
      }
      return chineseName;
    }

  },
  watch: {
    currentFilters: {
      handler(newData, oldData) {
        var columns = [];
        if (newData.policyType === 'P') {
          columns = columns.concat(this.defaultColumns, this.lifeColumns);

        }
        if (newData.policyType === 'G') {
          columns = columns.concat(this.defaultColumns, this.giColumns);
        }
        console.debug(columns)
        Vue.set(this, 'columns', columns);
      },
      deep: true
    }
  },
  computed: {
    exportLink() {
      return `
    $ { domain }
    /report/performance ?
    export = 1 & policyType = $ { this.currentFilters.type }
    `
    }
  },
  data() {
    return {
      currentFilters: {},
      filters: [{
          label: this.$t('dw.general.policyType'),
          key: 'policyType',
          type: 'select',
          default: 'G',
          haveAll: false,
        },
        {
          label: this.$t('dw.general.fromDate'),
          key: 'startDate',
          type: 'datetime',
          default: '',
        },
        {
          label: this.$t('dw.general.endDate'),
          key: 'endDate',
          type: 'datetime',
          default: '',
        }
      ],
      columns: [],
      lifeColumns: [{
          key: 'afyp',
          label: this.$t('dw.report.performance.afyp'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'fyc',
          label: this.$t('dw.report.performance.fyc'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'ifyp',
          label: this.$t('dw.report.performance.ifyp'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        }
      ],
      giColumns: [{
        key: 'commission',
        label: this.$t('dw.report.performance.commission'),
        sortable: true,
        formatter: (row, key, item) => {
          if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
          return '$ 0'
        }
      }],
      defaultColumns: [{
          key: 'agentCode',
          label: this.$t('dw.report.performance.agentCode'),
          thClass: ['tableMinWidth120'],
          sortable: true,
        }, {
          key: 'agentName',
          label: this.$t('dw.general.agentName'),
          formatter: (row, key, item) => {
            return '<div>' + this.convertEnglishName(item) + '</div>' +
              '<div>' + this.convertChineseName(item) + '</div>'
          }
        },
        {
          key: 'teamCode',
          label: this.$t('dw.report.performance.teamCode'),
          tdClass: ['text-center'],
          thClass: ['text-center'],
          sortable: true,
          formatter: (row, key, item) => {
            return Vue.options.filters.isEmpty(row)
          }
        },
        {
          key: 'cases',
          label: this.$t('dw.report.performance.cases'),
          tdClass: ['text-center'],
          thClass: ['text-center'],
          sortable: true,
        },
        {
          key: 'premium',
          label: this.$t('dw.report.performance.premium'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },

      ],
      autoSearchFilters: [{
        label: this.$t('dw.general.agent'),
        key: 'agentID',
        searchParams: {
          placeholder: ' Type to search',
          dest: 'option',
          paras: [{ key: 'type', value: 'agent' }],
          showItems: ['englishFullname', 'chineseFullname', 'agentCode']
        }
      }],
    }
  }
}

</script>
<style type="text/css">
.tableMinWidth120 {
  max-width: 120px;
}

.tableMinWidth150 {
  max-width: 150px;
}

.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: default !important;
}

</style>



// WEBPACK FOOTER //
// src/Dw/containers/ReportPerformance.vue